import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SharedIndex } from '../shared';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../store/hooks';
import { getHenryBMR } from '../../../shared/utils/utilFunctions';
import { metaDataSelector } from '../../../store/globalSelectors';
import {
  setHenrySummary,
  setHenryOxfordBMR,
  setHenryStressFactor,
  setHenryActivityFactor,
  setHenryOxfordSelection,
  setHenryActivityFactorPAL_Input,
  setHenryActivityFactorPAL_Select
} from '../../../store/slices/metaDataSlice';

const HenryOxford = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { patientInformation, estimatingRequirements } =
    useAppSelector(metaDataSelector);
  const { metric } = patientInformation;
  const {
    selection,
    stressFactor,
    activityFactor,
    activityFactorPAL_Input,
    activityFactorPAL_Select
  } = estimatingRequirements.henryOxford;

  useEffect(() => {
    dispatch(
      setHenryOxfordBMR(
        getHenryBMR(
          patientInformation?.age?.years,
          patientInformation?.gender.toLowerCase(),
          metric?.estimatedDryWeight || metric?.weight
        )
      )
    );
  }, []);

  const getNextRoute = useCallback(() => {
    const active = location.pathname;
    const bothOpted = selection?.stressFactor && selection?.activityFactor;
    const stressOpted = selection?.stressFactor && !selection?.activityFactor;
    const activityOpted = !selection?.stressFactor && selection?.activityFactor;

    if (
      active === '/estimating-requirements/henryOxford' &&
      (bothOpted || activityOpted)
    ) {
      return '/estimating-requirements/henryOxford/activityOrPAL';
    }
    if (
      (active === '/estimating-requirements/henryOxford' && stressOpted) ||
      (active === '/estimating-requirements/henryOxford/activityOrPAL' &&
        selection.stressFactor)
    ) {
      return '/estimating-requirements/henryOxford/stressFactor';
    }
    return patientInformation.type === 'PAEDIATRIC'
      ? '/estimating-requirements/paediatric-energy'
      : '/estimating-requirements/protein';
  }, [selection.stressFactor, selection.activityFactor, location.pathname]);

  return (
    <SharedIndex
      title={`HENRY OXFORD`}
      selection={selection}
      stressFactor={stressFactor}
      nextPageRoute={getNextRoute()}
      setSummaryVal={setHenrySummary}
      activityFactor={activityFactor}
      setStressFactor={setHenryStressFactor}
      setActivityFactor={setHenryActivityFactor}
      handleSelectionToggle={setHenryOxfordSelection}
      activityFactorPAL_Input={activityFactorPAL_Input}
      BMRVal={estimatingRequirements.henryOxford.bmr}
      summary={estimatingRequirements.henryOxford.summary}
      activityFactorPAL_Select={activityFactorPAL_Select}
      setActivityFactorPAL_Input={setHenryActivityFactorPAL_Input}
      setActivityFactorPAL_Select={setHenryActivityFactorPAL_Select}
    />
  );
};

export { HenryOxford };
